import React from 'react';
import { ViewCountDisplay } from './ViewCountDisplay';

/**
 * Hero header cluster: view count + favorite.
 * LTR (right side): eye · count · heart
 * RTL/fa (left side): heart · count · eye
 */
export const LearnerHeroViewFavoriteCluster: React.FC<{
  viewCount: number;
  viewCountClassName?: string;
  isRtl: boolean;
  viewTourId?: string;
  children: React.ReactNode;
}> = ({ viewCount, viewCountClassName, isRtl, viewTourId, children }) => (
  <div className="flex shrink-0 items-center gap-2" dir="ltr">
    {isRtl ? (
      <>
        {children}
        <ViewCountDisplay count={viewCount} className={viewCountClassName} iconPosition="end" dataTourId={viewTourId} />
      </>
    ) : (
      <>
        <ViewCountDisplay count={viewCount} className={viewCountClassName} iconPosition="start" dataTourId={viewTourId} />
        {children}
      </>
    )}
  </div>
);
